// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './context/AuthContext';
import { BlogProvider } from './context/BlogContext';
import { ThemeProvider } from './context/ThemeContext'; // if you have one
import { UserProvider } from './context/UserContext';
import App from './App'; // you shared App.js with the routes
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <UserProvider>
          <ThemeProvider>
            <BlogProvider>
              <App />
            </BlogProvider>
          </ThemeProvider>
        </UserProvider>
      </AuthProvider>
    </BrowserRouter>   
  // </ictMode>
);
